// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"a98017b33e96613d50dc","655":"1e5e47422eb22ed96d5e"}[chunkId] + ".js";
};